import type { PagesConfig } from '#types/config/pages'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    heading: 'subtitle-1'
  }
} satisfies RecursivePartial<PagesConfig['orderStatus']>
